module.exports = __webpack_public_path__ + "static/media/pickup.e1a688a6.mp3";